export { default } from "../client/router";
export * from "../client/router";

//# sourceMappingURL=router.js.map